import React from 'react'
import { useQuery } from '@apollo/client';
import { GET_CATEGORIES_NAV } from '../../utils/constants/queries';
import { ErrorComponent } from '../../components/';
import {SkeletonText,Stack} from "@chakra-ui/react"
import { Link } from 'react-router-dom';

export default function CategoryNav() {
    const { loading, error, data } = useQuery(GET_CATEGORIES_NAV);
    const catWidget =  (loading) ? <Stack><SkeletonText noOfLines={1}/><SkeletonText noOfLines={1}/><SkeletonText noOfLines={1}/><SkeletonText noOfLines={1}/></Stack>:
     (error) ? <ErrorComponent message={error.message}/>:
        data.category.map((cat)=>
        <li key={cat.id}><Link to={`/blog/${cat.category}/posts`}>{cat.category} ({cat.blogs_aggregate.aggregate.count})</Link></li>
        )
    return (
        <section className="widget widget_categories">
        <h3 className="widget-title">Categories</h3>
        <ul>
            {catWidget}
        </ul>
    </section>
    )
}
